import React, { useContext } from 'react';

import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { CandidatesContext } from '../../../../context/CandidatesContext';
import classes from './styles.module.scss';

export default function SubmitCandidateButton({ candidateId }) {
  const { showSubmitCandidateModal } = useContext(CandidatesContext);

  const { t } = useTranslation();

  const queryClient = useQueryClient();

  // Get all queries that start with 'candidates' since the query key includes multiple parameters
  const queriesData = queryClient.getQueriesData({
    predicate: ({ queryKey }) => {
      return Array.isArray(queryKey) && queryKey[0] === 'candidates';
    },
  });

  // Flatten all candidate data from all query results
  const allCandidates = queriesData.map(([, data]) => data?.data || []).flat();

  const candidate = allCandidates.find((cnd) => cnd.id === candidateId);

  return (
    <button
      className={classes.SubmitCandidateButton}
      type="button"
      onClick={(event) => {
        event.stopPropagation();
        showSubmitCandidateModal(candidate);
      }}
    >
      <span>{t('common.submit')}</span>
    </button>
  );
}
